<script lang="ts">
    import type { Artwork as ArtworkType } from '@amp/web-app-components/src/components/Artwork/types';
    import Artwork from '@amp/web-app-components/src/components/Artwork/Artwork.svelte';

    export let artwork: ArtworkType;
    export let title: string;

    //Adds support for Artwork w/ 16:9 aspect ratio
    export let isHdAspectRatio: boolean = false;
</script>

<div
    class="category-brick"
    class:is-hd-aspect-ratio={isHdAspectRatio}
    data-testid="category-brick"
>
    <Artwork {artwork} forceFullWidth={false} alt="" profile="category-brick" />
    {#if title}
        <h3 class="category-brick__title" data-testid="category-brick__title">
            {title}
        </h3>
    {/if}
</div>

<style lang="scss">
    @use 'amp/stylekit/core/mixins/hover-style' as *;
    @use 'amp/stylekit/core/mixins/line-clamp' as *;
    @use 'amp/stylekit/core/box-shadows' as *;
    @use '@amp/web-shared-styles/app/core/globalvars' as *;
    @use '@amp/web-shared-styles/app/core/mixins/aspect-ratio' as *;
    @use '@amp/web-shared-styles/app/core/mixins/absolute-center' as *;

    $artwork-minimum-height: 111px;
    $artwork-aspect-ratio: 3;

    .category-brick {
        position: relative;
        border-radius: var(
            --global-border-radius-large,
            #{$global-border-radius-large}
        );
        box-shadow: $global-default-content-box-shadow;
        overflow: hidden;
        z-index: var(--z-default);

        // TODO: We may be able to remove this block if other apps begin
        // to support Artwork with 16:9 aspect ratio
        &:not(.is-hd-aspect-ratio) {
            @media (--range-xsmall-only) {
                height: $artwork-minimum-height;

                :global(.artwork-component) {
                    --artwork-override-height: #{$artwork-minimum-height};

                    @include aspect-ratio($height: #{$artwork-minimum-height});

                    /*
                    * The artwork gets fixed to its minimum height
                    * and is anchored to its centerpoint while being
                    * cropped on its sides.
                    */
                    @include absolute-center(cropped);
                }
            }
        }

        &::after {
            @include content-container-hover-style;

            :global(a:hover) &,
            :global(a:focus) & {
                @include content-container-hover-active-style;
            }
        }
    }

    .category-brick__title {
        padding-inline-start: 12px;
        padding-inline-end: 12px;
        bottom: 9px;
        color: white;
        position: absolute;
        pointer-events: none;
        font: var(--title-1-emphasized);
        z-index: calc(
            var(--z-default) + 1
        ); // put title on separate layer so it isn't dimmed by container hover effect

        @include line-clamp(2);

        @media (--large) {
            bottom: 11px;
            padding-inline-start: 16px;
            padding-inline-end: 16px;
        }
    }
</style>
